angular.module('picmonicng').directive('sharedPlaylistClone', [
  'PlaylistService',
  'BrowseService',
  'UserService',
  '$state',
  function (PlaylistService, BrowseService, UserService, $state) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function () {
          if (!UserService.user.user_id) {
            return;
          }

          scope.$apply(function () {
            if (typeof attrs.href == 'undefined' || attrs.href == '#') {
              scope.loading = true;
              PlaylistService.duplicate({
                playlist_id: attrs.playlistId,
                name: attrs.playlistName,
              })
                .then(function (response) {
                  if (attrs.slug) {
                    var promise = $state.go('app.learn', { slug: attrs.slug });
                    promise.then(function () {
                      BrowseService.go('app.playlist', {
                        playlist_id: response.playlist_id,
                      });
                    });
                  } else {
                    BrowseService.go('app.playlist', {
                      playlist_id: response.playlist_id,
                    });
                  }
                })
                .finally(function () {
                  scope.loading = false;
                });
            }
          });
        });
      },
    };
  },
]);
